// 递归转换树结构
// 源数据, 最上级ID,名称,父ID名称,创建子级名称

export function handleTree(data, root, idTxt, pidTxt, pushTxt) {
  var idTxt = idTxt || "id";
  var pidTxt = pidTxt || "pid";
  var pushTxt = pushTxt || "children";
  // 递归方法
  function getNode(id) {
    var node = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i][pidTxt] == id) {
        data[i][pushTxt] = getNode(data[i][idTxt]);
        node.push(data[i]);
      }
    }
    if (node.length == 0) {
      return;
    } else {
      return sortFn(node);
    }
  }
  // 使用根节点
  return getNode(root) ?sortFn(getNode(root)):'';
}
//排序
export function sortFn(data){
    function sortDownDate(a, b) {
        return Date.parse(a.params) - Date.parse(b.params);
    }
    return data.sort(sortDownDate);
}
// 转换年月日 增加年份层级
export function toTreeData(data) {
  let result = [];
  let resultKeys = {};
  data.map((item,index) => {
    let yearKey = item.groupName.substring(0, 4);
    let monthKey = item.groupName.substring(4, 6);
    let daykey = item.groupName.substring(6, 8);
    
    // 1. 添加年份节点
    if (!resultKeys[yearKey]) {
      result.push({
        id: yearKey,
        pid: -1,
        name: yearKey,
        params: yearKey,
        dateType: "year"

      });
      resultKeys[yearKey] = true;
    }
    
    // 2. 添加月份节点，父节点为年份
    let yearMonthKey = yearKey + monthKey;
    if (!resultKeys[yearMonthKey]) {
      result.push({
        id: yearMonthKey,
        pid: yearKey,
        name: yearKey + "-" + monthKey,
        params: yearKey + "-" + monthKey,
        dateType: "month"
      });
      resultKeys[yearMonthKey] = true;
    }
    
    // 3. 添加日期节点，父节点为月份
    result.push({
      id: daykey+1,
      groupId: item.groupName,
      pid: yearMonthKey,
      outnum: item.outNum,
      innum: item.totalNum,
      kucun: item.totalNum - item.outNum,
      params: `${yearKey}-${monthKey}-${daykey}`,
      name:
        monthKey +
        "-" +
        daykey,
        dateType: "day" 
        // +
        // ` (${item.totalNum - item.outNum}/${item.totalNum})`
    });
  });
  return handleTree(result,-1);
}
